import { Component, Input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { faSolidChevronDown } from '@ng-icons/font-awesome/solid';

@Component({
    selector: 'app-accordion-item',
    imports: [NgIcon],
    templateUrl: './accordion-item.component.html',
    styleUrl: './accordion-item.component.scss',
    providers: [provideIcons({ faSolidChevronDown })]
})
export class AccordionItemComponent {
  @Input()
  isOpen = false;
}
